const getPath = (path: string, groupId?: string, enterpriseGroupBuyId?: string) => {
  if (!!groupId) return `/group/${groupId}${path}`;
  if (!!enterpriseGroupBuyId) return `/enterpriseGroupBuy/${enterpriseGroupBuyId}${path}`;
  return path;
};

export default getPath;
